var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinkedinGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59589 15.0333H6.64033V8.679H8.59589V15.0333ZM7.61811 7.86378C6.91248 7.86378 6.55967 7.53785 6.55967 6.886C6.55748 6.75527 6.58366 6.62561 6.63641 6.50598C6.68916 6.38634 6.76723 6.27956 6.86522 6.193C7.06917 6.00308 7.33953 5.90082 7.61811 5.90822C8.32374 5.90822 8.67656 6.23456 8.67656 6.88722C8.67656 7.86622 8.32456 7.86378 7.61811 7.86378ZM13.8527 15.0333V11.4889C13.8527 10.5657 13.5263 10.1041 12.8737 10.1041C12.3587 10.1041 12.0189 10.362 11.8543 10.8778C11.8014 10.9601 11.7745 11.123 11.7737 11.3667V15.0333H9.77778V10.7152C9.77778 9.73744 9.76433 9.0587 9.73744 8.679H11.4486L11.5708 9.53333C12.0193 8.85378 12.6708 8.51522 13.5667 8.51522C14.247 8.51522 14.797 8.75274 15.2167 9.22778C15.6387 9.70282 15.8498 10.3889 15.8498 11.286V15.0333H13.8527ZM11 22C4.93411 22 0 17.0659 0 11C0 4.93411 4.93411 0 11 0C17.0659 0 22 4.93411 22 11C22 17.0659 17.0659 22 11 22ZM11 2.44444C6.28344 2.44444 2.44444 6.28344 2.44444 11C2.44444 15.7166 6.28344 19.5556 11 19.5556C15.7166 19.5556 19.5556 15.7166 19.5556 11C19.5556 6.28344 15.7166 2.44444 11 2.44444Z",
    fill: "#08BD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedinGreen);
export default __webpack_public_path__ + "static/media/ic_linkedin_green.b1ef33dde812b3346dfe27a3bbb789fa.svg";
export { ForwardRef as ReactComponent };